export default "__VITE_ASSET__BibNo3Qx__"